"use strict";

var NOTIFICATION_TEMPLATE =
    '<div class="bfNotification bfNotification--{0}"><div class="bfNotification__close"><i class="bf-icon bf-icon-close-outlined"></i><i class="bf-icon bf-icon-close-filled"></i></div><div class="bfNotification__text">{1}</div><i class="bfNotification__icon bf-icon bf-icon-{2}"></i></div>';

/* A service / model */
_BannerFlowApp.factory("Notification", function () {
    return {
        Show: function (text, delay, type, icon) {
            var self = this;
            delay = delay || 3000;
            type = type || "info";

            if (!icon) {
                if (type === "info" || type === "success") {
                    icon = "finished";
                } else if (type === "warning" || type === "error") {
                    icon = "alert";
                }
            }
            //Hide eventual showing notification
            this.Hide();

            this._notificationElement = $(NOTIFICATION_TEMPLATE.format(type, text, icon));
            this._notificationElement.on("click", function () {
                self.Hide();
            });

            if (delay > 0) {
                self._timer = setTimeout(function () {
                    self.Hide();
                }, delay);
            }

            $("body").append(this._notificationElement);
        },
        Hide: function () {
            window.clearTimeout(this._timer);

            if (this._notificationElement) {
                this._notificationElement.off("click");
                this._notificationElement.remove();
            }
        },
        _notificationElement: null,
        _timer: null
    };
});
